/// <reference path="../_references.ts"/>

module App.WorkOrder {

	import BannerService = App.WorkOrder.BannerService;
	import Package = App.PriceGuide.Package;

	export class BannerFlyoutController {

		banners: Banner[];
		selectedBanner: number = null;

		static $inject: string[] = ['BannerService'];

		constructor(public BannerService: BannerService) {

			const vm = this;

			vm.loadBanners();
		}

		loadBanners() {
			const vm = this;

			vm.BannerService.getPackageBanners().then((response) => {
				vm.banners = response.data;
			});
		}

		toggleSelectedBanner(banner: Banner, pkg: Package) {
			const vm = this;

			if(pkg.banner) {
				vm.selectedBanner = pkg.banner.id;
			}

			if(!pkg.banner || pkg.banner.id !== banner.id) {
				pkg.banner = banner;
				vm.selectedBanner = pkg.banner.id;
			} else {
				pkg.banner = null;
				vm.selectedBanner = null;
			}
		}
	}
}
